<div class="w-full h-full flex flex-col">
    <div class="w-full p-4 flex items-center justify-between">
        <div class="flex items-center gap-4">
            <div class="font-medium text-dark-800 text-2xl">Insights Dashboards</div>
            <button mat-stroked-button (click)="useFullscreenDashboard()" [matTooltip]="'Enter Fullscreen'">
                <myrtls-icon [icon]="'fullscreen'"></myrtls-icon>
            </button>
        </div>
        <div class="flex gap-4 items-center">
            @if (($loading | async) !== false) {
                <mat-progress-spinner [diameter]="30" [mode]="'indeterminate'"></mat-progress-spinner>
            }
            @if (($loading | async) === false && $dashboards().dashboards.length > 0) {
                <mat-form-field>
                    <mat-label>Dashboard</mat-label>
                    <mat-select [formControl]="dashboard">
                        @for (dashboard of $dashboards().dashboards || []; track dashboard) {
                            <mat-option [value]="dashboard.id">
                                {{ dashboard.title | replaceString: siteIdRegexp : '' }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }
        </div>
    </div>
    @if (($loading | async) === false && $dashboards().dashboards.length === 0) {
        <div class="w-full grow flex items-center justify-center border-t border-slate-200 text-dark-800">No dashboards available.</div>
    }
    <div #supersetDashboard [hidden]="$dashboards().dashboards.length === 0" class="w-full grow border-t border-slate-200"></div>
</div>
